import { Component, Input } from '@angular/core';
import { AppTheme } from 'src/app/shared/constants/global-config.constant';

/**
 * The /payment-success "ready - tap to start" screen the app can always show by itself:
 * when the branch has no picture of its own, or its picture has not arrived in time.
 *
 * It is drawn into the page (inline SVG): no fonts, no pictures, nothing to download, so it
 * appears with the internet down or the browser cache just cleared. It replaces the old
 * ready-gray.png, which had to be downloaded like any other picture and so failed exactly
 * when it was needed. Two looks, approved 18 Oct 2026: the default (grey, SCULPTURE bands)
 * and the_portrait (black, THE PORTRAIT).
 */
@Component({
  selector: 'app-ready-fallback',
  templateUrl: './ready-fallback.component.html',
  styleUrls: ['./ready-fallback.component.scss']
})
export class ReadyFallbackComponent {

  /** AppTheme.DEFAULT or AppTheme.THE_PORTRAIT. */
  @Input() theme: string = AppTheme.DEFAULT;

  readonly AppTheme = AppTheme;

  /** SCULPTURE repeats along each band: enough copies to cross any booth screen. */
  readonly bandCopies = Array.from({ length: 8 }, (_, i) => i);
}
